<template>
    <div>
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="line"></div>
            <div class="page-title">发票管理</div>
            <el-button type="text" class="add-invoice-btn" @click="openAddressDialog">
                + 新增抬头
            </el-button>
        </div>

        <!-- 发票表格 -->
        <el-table :data="invoices" :border="true" class="invoice-table">
            <!-- 标签列 -->
            <el-table-column label="标签" width="100">
                <template slot-scope="scope">
                    <el-tag>
                        {{ scope.row.type_str }}
                    </el-tag>
                </template>
            </el-table-column>
            <!-- 收货人/公司名列 -->
            <el-table-column label="收货人" min-width="150">
                <template slot-scope="scope">{{ scope.row.username }}</template>
            </el-table-column>

            <!-- 联系邮箱列 -->
            <el-table-column label="联系邮箱" min-width="200">
                <template slot-scope="scope">{{ scope.row.email }}</template>
            </el-table-column>

            <!-- 联系方式列 -->
            <el-table-column label="联系方式" width="150">
                <template slot-scope="scope">{{ scope.row.mobile }}</template>
            </el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <div class="action-buttons">
                        <el-button type="text" size="small" class="edit-btn" @click="editAddressFn(scope.row)">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" class="delete-btn"
                            @click.native="dialogVisibleDelete = true; chooseAddress = scope.row">
                            删除
                        </el-button>
                        <el-button type="primary" size="small" plain :disabled="scope.row.is_default == 1"
                            class="default-btn" @click="setFapiaoFn(scope.row)">
                            {{ scope.row.is_default == 1 ? '默认发票' : '设置默认' }}
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>



        <el-dialog title="新增发票抬头" :visible.sync="dialogVisible" width="80%" :before-close="handleClose"
            v-if="dialogVisible">
            <div>
                <NewFapiao ref="NewFapiao" @fapiaoAdded="handleAddressAdded" @close="handleClose"
                    :address="chooseAddress" :isEdit="isEdit"></NewFapiao>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>

        <el-dialog title="提示" :visible.sync="dialogVisibleDelete" width="30%" :before-close="handleClose">
            <span>是否删除该发票？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleDelete = false">取 消</el-button>
                <el-button type="primary" @click="deleteFapiaoFn(chooseAddress)">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import NewFapiao from '../../../purchase/components/NewFapiao.vue'

export default {
    name: 'InvoiceManagement',
    components: {
        NewFapiao
    },
    data() {
        return {
            // 发票数据
            invoices: [],

            // 分页数据
            // currentPage: 1,
            // pageSize: 10,
            // totalOrders: 0,


            dialogVisible: false,
            dialogVisibleDelete: false,
            chooseAddress: {},
            isEdit: false
        }
    },

    mounted() {
        this.getFapiaoList();
    },
    methods: {
        openAddressDialog() {
            this.isEdit = false
            // this.resetForm(); // 新增时重置表单
            this.chooseAddress = {}
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.NewFapiao.resetForm(); // 在对话框渲染完成后调用resetForm方法
            });
        },
        // 处理发票添加成功事件
        handleAddressAdded() {
            // 发射事件通知父组件
            this.$emit('fapiaoListUpdated');
            this.getFapiaoList()
        },

        // 设置默认发票
        setFapiaoFn(address, index) {
            console.log('设置默认发票', address);
            this.$dapi.setFapiaoFn({
                aid: address.aid
            }).then(res => {
                this.$message.success('设置默认发票成功');
                this.$emit('setFapiaoFn', address);
                // 重新获取发票列表以刷新表格数据
                this.getFapiaoList();
            }).catch(err => {
                this.$message.error(err);
            })
        },

        handleClose() {
            this.dialogVisible = false;
        },

        // 删除发票
        deleteFapiaoFn(address, index) {
            console.log(address);

            this.$dapi.deleteFapiaoFn({
                aid: address.aid
            }).then(res => {
                this.$message.success('删除发票成功');
                this.$emit('fapiaoListUpdated');
                // 重新获取发票列表以刷新表格数据
                this.getFapiaoList();
                this.dialogVisibleDelete = false
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 编辑发票
        editAddressFn(address) {
            console.log('打开弹窗');
            this.chooseAddress = JSON.parse(JSON.stringify(address));
            this.dialogVisible = true
            this.isEdit = true
        },
        // 获取发票列表
        getFapiaoList() {
            // let data = {
            //     page: this.currentPage,
            //     list_rows: this.pageSize,
            // }
            this.$api.getFapiaoList().then(res => {
                this.invoices = res
            }).catch(err => {
                this.$message.error(err.msg);
                console.log(err);
            })
        }
    }
}
</script>

<style scoped>
/* 页面标题 */
.page-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

.add-invoice-btn {
    margin-left: auto;
    color: #FF9735;
    font-size: 16px;
}

/* 发票表格 */
.invoice-table {
    border-radius: 8px;
    overflow: hidden;
}

/* 表格操作按钮 */
.action-buttons {
    display: flex;
    /* flex-direction: column; */
    gap: 8px;
    align-items: center;
}

.edit-btn {
    color: #286CED;
}

.delete-btn {
    color: #ff4d4f;
}

.default-btn {
    border-color: #286CED;
    color: #286CED;
}

.default-btn:disabled {
    background-color: #286CED;
    color: #fff;
    border-color: #286CED;
}

/* Element UI 表格样式调整 */
::v-deep .el-table__header-wrapper th {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #666;
    font-size: 14px;
}

::v-deep .el-table__body-wrapper td {
    font-size: 14px;
    color: #333;
}

::v-deep .el-table__body-wrapper tr:last-child td {
    border-bottom: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .action-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
    }
}
</style>